import { useState, useCallback, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { Btn } from "./ui/Btn";
import { TopNav } from "./ui/TopNav";
import { Chip } from "./ui/Chip";
import { EmptyBox } from "./WorkFlow";

// ─── PANEL ADMIN ─────────────────────────────────────────────────────────────
// eslint-disable-next-line no-unused-vars
export const AdminPanel = ({setScreen}) => {
  const [auth,        setAuth]        = useState(false);
  const [pass,        setPass]        = useState("");
  const [passErr,     setPassErr]     = useState("");
  const [workers,     setWorkers]     = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [actionMsg,   setActionMsg]   = useState("");

  const login = () => {
    if (pass === "ficio2026") { setAuth(true); cargar(); }
    else { setPassErr("Contraseña incorrecta."); }
  };

  const cargar = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from("trabajadores")
      .select("id,nombre,oficio,ciudad,zona,plan,telefono,correo,email,foto_url,ine_url,membresia,created_at")
      .eq("verificado", false)
      .neq("archivado", true)
      .order("created_at", { ascending: false });
    setWorkers(data || []);
    setLoading(false);
  }, []);

  const aprobar = async (id) => {
    setActionMsg("");
    const { error } = await supabase
      .from("trabajadores")
      .update({ verificado: true, membresia: "activa", membresia_activa: true })
      .eq("id", id);
    if (error) { setActionMsg("Error: " + error.message); return; }
    setActionMsg("✓ Trabajador aprobado y membresía activada.");
    setWorkers(prev => prev.filter(w => w.id !== id));
  };

  const archivar = async (id) => {
    setActionMsg("");
    const { error } = await supabase
      .from("trabajadores")
      .update({ archivado: true, visible_directorio: false })
      .eq("id", id);
    if (error) { setActionMsg("Error: " + error.message); return; }
    setActionMsg("Trabajador archivado.");
    setWorkers(prev => prev.filter(w => w.id !== id));
  };

  if (!auth) return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:C.surface,borderRadius:22,padding:28,maxWidth:380,width:"100%",boxShadow:"0 8px 32px rgba(0,0,0,.1)"}}>
        <div style={{fontFamily:"Georgia,serif",fontSize:26,fontWeight:900,color:C.text,marginBottom:6}}>🔒 Admin Ficio</div>
        <div style={{color:C.muted,fontSize:13,marginBottom:20}}>Panel de administración</div>
        <input
          type="password"
          placeholder="Contraseña de admin"
          value={pass}
          onChange={e=>{setPass(e.target.value);setPassErr("");}}
          onKeyDown={e=>e.key==="Enter"&&login()}
          style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,padding:"12px 14px",fontSize:14,color:C.text,outline:"none",marginBottom:10}}
        />
        {passErr && <div style={{color:C.red,fontSize:12,marginBottom:10}}>{passErr}</div>}
        <Btn full color={C.accent} onClick={login}>Entrar</Btn>
        <div style={{height:10}}/>
        <Btn full outline color={C.muted} onClick={()=>setScreen("landing")}>Volver al inicio</Btn>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:60}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Admin — Trabajadores pendientes"/>
      <div style={{maxWidth:680,margin:"0 auto",padding:"20px"}}>
        {actionMsg && (
          <div style={{background:C.greenL,border:`1px solid ${C.green}30`,borderRadius:12,padding:"10px 14px",color:C.green,fontSize:13,fontWeight:700,marginBottom:14}}>
            {actionMsg}
          </div>
        )}
        <Btn outline color={C.accent} onClick={cargar} style={{marginBottom:16}}>↻ Refrescar</Btn>
        {loading ? (
          <div style={{textAlign:"center",padding:"40px 0",color:C.muted}}>Cargando...</div>
        ) : workers.length === 0 ? (
          <EmptyBox icon="✅" title="Sin pendientes" desc="Todos los trabajadores han sido revisados."/>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {workers.map(w => (
              <div key={w.id} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:16,boxShadow:"0 2px 6px rgba(0,0,0,.04)"}}>
                <div style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:10}}>
                  {w.foto_url
                    ? <img src={w.foto_url} alt="" style={{width:52,height:52,borderRadius:12,objectFit:"cover",flexShrink:0}}/>
                    : <div style={{width:52,height:52,borderRadius:12,background:C.accentL,display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>🔨</div>
                  }
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontFamily:"Georgia,serif",fontSize:16,fontWeight:900,color:C.text}}>{w.nombre || "Sin nombre"}</div>
                    <div style={{color:C.muted,fontSize:12}}>
                      {w.oficio} · {w.ciudad || w.zona || "Los Mochis"} · Plan {w.plan || "básico"}
                    </div>
                    <div style={{color:C.muted,fontSize:12}}>📱 {w.telefono || "—"} · ✉️ {w.correo || w.email || "—"}</div>
                    <div style={{color:C.muted,fontSize:11,marginTop:2}}>
                      Registrado: {w.created_at ? new Date(w.created_at).toLocaleDateString("es-MX") : "—"}
                    </div>
                  </div>
                </div>
                {w.ine_url && (
                  <a href={w.ine_url} target="_blank" rel="noopener noreferrer"
                    style={{display:"inline-block",background:C.blueL,color:C.blue,borderRadius:8,padding:"4px 10px",fontSize:11,fontWeight:700,textDecoration:"none",marginBottom:10}}>
                    📄 Ver INE
                  </a>
                )}
                <div style={{display:"flex",gap:8}}>
                  <Btn small color={C.green} onClick={()=>aprobar(w.id)}>✓ Aprobar</Btn>
                  <Btn small outline color={C.red} onClick={()=>archivar(w.id)}>✕ Archivar</Btn>
                  {w.telefono && (
                    <a href={`https://wa.me/52${String(w.telefono).replace(/\D/g,"")}?text=${encodeURIComponent("Hola "+w.nombre+", tu cuenta en Ficio ha sido activada. Ya puedes recibir solicitudes de trabajo.")}`}
                      target="_blank" rel="noopener noreferrer"
                      style={{display:"inline-flex",alignItems:"center",gap:4,background:C.greenL,color:C.green,borderRadius:10,padding:"8px 12px",fontSize:12,fontWeight:700,textDecoration:"none"}}>
                      💬 WhatsApp
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export const ClientesAdminLocal = ({setScreen}) => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);

  const cargar = useCallback(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("clientes")
      .select("*")
      .order("created_at", { ascending:false });

    if (!error) setClientes(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="cuenta" backLabel="Cuenta" title="Clientes"/>
      <div style={{maxWidth:640,margin:"0 auto",padding:"20px"}}>
        <div style={{fontFamily:"Georgia, serif",fontSize:24,fontWeight:900,color:C.text,marginBottom:4}}>
          Clientes registrados
        </div>
        <div style={{color:C.muted,fontSize:13,marginBottom:16}}>
          Esta vista local te ayuda a comprobar que los clientes se están guardando.
        </div>

        {loading ? (
          <div style={{textAlign:"center",padding:"42px 0",color:C.muted}}>Cargando clientes...</div>
        ) : clientes.length === 0 ? (
          <EmptyBox icon="🏠" title="Sin clientes registrados" desc="Cuando un cliente cree cuenta aparecerá aquí."/>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {clientes.map(c=>(
              <div key={c.id || c.user_id} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:16,padding:15}}>
                <div style={{fontFamily:"Georgia, serif",fontSize:17,fontWeight:900,color:C.text}}>{c.nombre || "Cliente"}</div>
                <div style={{color:C.muted,fontSize:12}}>📱 {c.telefono || "Sin teléfono"} · ✉️ {c.email || "Sin correo"}</div>
                <div style={{display:"flex",gap:6,marginTop:8,flexWrap:"wrap"}}>
                  <Chip text={c.status || "activo"} color={C.green} small/>
                  {c.zona && <Chip text={c.zona} color={C.blue} small/>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
